import './style/index.css';
import './style/tailwind.css';
import App from './components/app';

export default App;
